import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import * as ReactGA from '../../GA';
import TranslatedText from '../../atoms/TranslatedText';
import MainMenu from '../../atoms/MainMenu';

import prizmImage from './Prizm.png';
import hdo from './HDO.png';
import HdpImage from './HDP.png';
import switchLock from './Switchlock.png';
import stealth from './Stealth.png';
import trubridge from './TruBridge.png';
import otd from './OTD.png';
import SportSpec from './SportSpec.png';

import './Home.css';
import {ROUTES} from '../../routes';

const HomeItem = props => {
    const linksNumber = props.children.length ? props.children.length : '1';
    return (
        <div className="Home-item">
            <div className="Home-item-content">
                <header
                    className="Home-item-header"
                    style={{backgroundImage: `url(${props.backgroundImage})`}}>
                    <h3 className="Home-item-title">
                        <TranslatedText tag={props.title} />
                    </h3>
                    <p className="Home-item-desc">
                        <TranslatedText tag={props.description} />
                    </p>
                </header>
            </div>
            <div className={`Home-item-btns Home-item-btns--${linksNumber}`}>
                {props.children}
            </div>
        </div>
    );
};

const HomeItemButton = props => (
    <Link to={props.to}>
        <TranslatedText tag={props.tag} />
    </Link>
);

export default class Home extends PureComponent {
    componentDidMount() {
        ReactGA.pageview('Home');
    }
    render() {
        return (
            <article className="Home-bg">
                <MainMenu />
                <div className="Home-scroll">
                    <div className="Home">
                        <h1 className="Home-logo">
                            <span className="hidden">Mad Science</span>
                        </h1>
                        <div className="Home-items">
                            <HomeItem
                                title="home.prizm.title"
                                description="home.prizm.description"
                                backgroundImage={prizmImage}>
                                <HomeItemButton
                                    to={ROUTES.PRIZM_ENHANCED}
                                    tag="home.prizm.enhanced_visibility"
                                />
                                <HomeItemButton
                                    to={ROUTES.PRIZM_HOWITWORKS}
                                    tag="home.prizm.how_it_works"
                                />
                                <HomeItemButton
                                    to={ROUTES.PRIZM_WORNBYTHEBEST}
                                    tag="home.prizm.worn_best"
                                />
                                <HomeItemButton
                                    to={ROUTES.PRIZM_SEEFORYOURSELF}
                                    tag="home.prizm.see_yourself"
                                />
                            </HomeItem>

                            <HomeItem
                                title="home.hdpolarized.title"
                                description="home.hdpolarized.description"
                                backgroundImage={HdpImage}>
                                <HomeItemButton
                                    to={ROUTES.HDPOLARIZED_CUTSGLARE}
                                    tag="home.hdpolarized.cuts_glare"
                                />
                                <HomeItemButton
                                    to={ROUTES.HDPOLARIZED_SINGLELAYER_OAKLEY}
                                    tag="home.hdpolarized.single_layer"
                                />
                            </HomeItem>

                            <HomeItem
                                title="home.high_definition_optics.title"
                                description="home.high_definition_optics.description"
                                backgroundImage={hdo}>
                                <HomeItemButton
                                    to={ROUTES.HIGH_DEFINITION_OPTICS_CLARITY}
                                    tag="home.high_definition_optics.clarity"
                                />
                                <HomeItemButton
                                    to={ROUTES.HIGH_DEFINITION_OPTICS_IMPACT}
                                    tag="home.high_definition_optics.impact_protection"
                                />
                            </HomeItem>

                            <HomeItem
                                title="home.oakley_stealth.title"
                                description="home.oakley_stealth.description"
                                backgroundImage={stealth}>
                                <HomeItemButton
                                    to="/oakley-stealth/hydrophobic"
                                    tag="home.oakley_stealth.hydrophobic"
                                />
                                <HomeItemButton
                                    to="/oakley-stealth/oleophobic"
                                    tag="home.oakley_stealth.oleophobic"
                                />
                                <HomeItemButton
                                    to="/oakley-stealth/antireflection"
                                    tag="home.oakley_stealth.antireflection"
                                />
                            </HomeItem>

                            <HomeItem
                                title="home.true_digital.title"
                                description="home.true_digital.description"
                                backgroundImage={otd}>
                                <HomeItemButton
                                    to="/oakley-true-digital/"
                                    tag="home.true_digital.learn_more"
                                />
                            </HomeItem>

                            <HomeItem
                                title="home.sport_specific_progressives.title"
                                description="home.sport_specific_progressives.description"
                                backgroundImage={SportSpec}>
                                <HomeItemButton
                                    to="/sport-specific-progressives/cycling"
                                    tag="home.sport_specific_progressives.cycling"
                                />
                                <HomeItemButton
                                    to="/sport-specific-progressives/golf"
                                    tag="home.sport_specific_progressives.golf"
                                />
                                <HomeItemButton
                                    to="/sport-specific-progressives/angling"
                                    tag="home.sport_specific_progressives.angling"
                                />
                            </HomeItem>

                            <HomeItem
                                title="home.switchlock.title"
                                description="home.switchlock.description"
                                backgroundImage={switchLock}>
                                <HomeItemButton
                                    to={ROUTES.SWITCHLOCK_AIRBRAKESNOW}
                                    tag="home.switchlock.airbrake-snow"
                                />
                                <HomeItemButton
                                    to={ROUTES.SWITCHLOCK_AIRBRAKEMX}
                                    tag="home.switchlock.airbrake-mx"
                                />
                                <HomeItemButton
                                    to={ROUTES.SWITCHLOCK_JAWBREAKER}
                                    tag="home.switchlock.jawbreaker"
                                />
                            </HomeItem>

                            <HomeItem
                                title="home.trubridge.title"
                                description="home.trubridge.description"
                                backgroundImage={trubridge}>
                                <HomeItemButton
                                    to="/trubridge/tecnology"
                                    tag="home.trubridge.tecnology"
                                />
                                <HomeItemButton
                                    to="/trubridge/sizing"
                                    tag="home.trubridge.sizing"
                                />
                            </HomeItem>
                        </div>
                    </div>
                </div>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/Home/Home.js